/**
 * Dev (local Vite + App Engine enrollio-development) is not embedded in GHL,
 * so email/password login should not depend on the /ghl-authorize SSO handoff.
 *
 * Staging/prod must keep /ghl-authorize. Match the GCP project host segment only;
 * do not treat "dev" substrings in other hosts as standalone-dev.
 */
export const isEnrollioDevelopmentPortalUrl = (portalUrl: string): boolean =>
  /(?:^|[.-])enrollio-development(?:\.|$)/.test(portalUrl);

export const isEnrollioStagingPortalUrl = (portalUrl: string): boolean =>
  /(?:^|\/\/|[.-])enrollio-portal-staging(?:\.|$)/.test(portalUrl);

const matchesBakedOrLivePortalUrl = (
  match: (portalUrl: string) => boolean,
): boolean => {
  if (match(String(import.meta.env.VITE_STUDIO_PORTAL_URL ?? ''))) {
    return true;
  }

  // Live default service hostname can differ from the baked VITE_STUDIO_PORTAL_URL.
  if (typeof window !== 'undefined') {
    return match(window.location.hostname);
  }

  return false;
};

export const isStandaloneDevEnvironment = (): boolean => {
  // Local `vite` / `vite dev` only. Deployed staging/prod builds are always PROD.
  if (import.meta.env.DEV) {
    return true;
  }

  return matchesBakedOrLivePortalUrl(isEnrollioDevelopmentPortalUrl);
};

/**
 * Dev-only Studio Tools under More (V2 Mode, manual cron triggers).
 * Visible on local Vite, App Engine development, and staging — never production.
 * Do not use `import.meta.env.PROD`: deployed dev/staging builds are also PROD.
 */
export const isDevOptionsVisible = (): boolean => {
  if (import.meta.env.DEV) {
    return true;
  }

  return matchesBakedOrLivePortalUrl(
    (portalUrl) =>
      isEnrollioDevelopmentPortalUrl(portalUrl) ||
      isEnrollioStagingPortalUrl(portalUrl),
  );
};
